export const safetyTermSection = '/safety-terms/'

export const safetyTermListUrl = (): string => safetyTermSection
